import {inject, Injectable, resource} from '@angular/core';
import {Observable} from 'rxjs';
import {take} from 'rxjs/operators';
import {FraisFixeDTO} from '../../dtos/frais-fixe-dto';
import {HttpService} from '../technique/http.service';
import {GraphQLService} from '../technique/graphql.service';
import {Auth2Service} from '../security/auth2.service';
import {ResponseWrapper} from '../../suppliers/wrappers/response-wrapper';
import {IsDeletableObject} from '../../models/is-deletable-object';
import {ObjectDTO} from '../../dtos/object-dto';

@Injectable({providedIn: 'root'})
export class FraisFixeService {

  private readonly httpSvc = inject(HttpService);
  private readonly graphQlSvc = inject(GraphQLService);
  private readonly auth2Svc = inject(Auth2Service);

  fraisFixeResource(typeFraisFixeList?: string[]) {
    return resource<FraisFixeDTO[], void>({
      loader: async () => {
        const siteIds = this.auth2Svc.utilisateur.sites.map(s => s.id);
        const typeFilter = typeFraisFixeList?.length
          ? `, typeFraisFixeList: [${typeFraisFixeList.map(t => `"${t}"`).join(', ')}]`
          : '';
        const response: any = await this.graphQlSvc.sendQuery(`
          {
            allFraisFixes(filters: { siteIds: [${siteIds}]${typeFilter} }) {
              id,
              code,
              libelle,
              typeFraisFixe,
              taxe { id, libelle, valeur, actif },
              site { id, libelle }
            }
          }
        `).pipe(take(1)).toPromise();
        return (response?.allFraisFixes ?? []) as FraisFixeDTO[];
      }
    });
  }

  save = (dto: FraisFixeDTO): Observable<ResponseWrapper<FraisFixeDTO>> =>
    this.httpSvc.post('dolrest/referentiel/facturation/frais-fixe/save', dto);

  delete = (ids: number[]): Observable<ResponseWrapper<IsDeletableObject>> =>
    this.httpSvc.delete(`dolrest/referentiel/facturation/frais-fixe/delete?ids=${ids.join(',')}`);

  canModify = (dto: ObjectDTO): boolean => {
    if (!dto || !dto?.site || !dto?.site.id) {
      return true;
    }
    return this.auth2Svc.isSiteLocal(dto.site.id);
  };
}
